import useOnlineStatus from '@rehooks/online-status';
import MultiField from 'Components/Forms/MultiField';
import api from 'Services/api';
import valueStore from 'Services/valueStore';
import { useEffect, useState } from 'react';

const AttendeesList = ({ attendees, push, remove, required = false, ...props }) => {
  const isOnline = useOnlineStatus();
  const [suggestions, setSuggestions] = useState([]);

  const sync = () => {
    const getAttendees = async () => await api.fetchAttendees();

    getAttendees().then(async (attendeesList) => {
      const values = attendeesList.map((attendee) => attendee.name);
      setSuggestions(values);
      await valueStore.set(`attendees`, values);
    });
  };

  useEffect(() => {
    const loadAttendees = async () => {
      if (isOnline) {
        sync();
      } else {
        const storedAttendees = await valueStore.getArray(`attendees`);
        setSuggestions(storedAttendees || []);
      }
    };

    loadAttendees();
  }, [isOnline]);

  return (
    <MultiField
      name="attendees"
      values={attendees}
      push={push}
      remove={remove}
      label="Attendees"
      placeholder="Add new attendee"
      required={required}
      suggestions={suggestions}
      isSortable={false}
      valueKey="description"
    />
  );
};

export default AttendeesList;
